/*
 * dashboard actions
 */

export const GET_FIGURE_DATA = 'GET_FIGURE_DATA';
export const GET_FIGURE_DATA_SUCCESS = 'GET_FIGURE_DATA_SUCCESS';
export const GET_FIGURE_DATA_FAIL = 'GET_FIGURE_DATA_FAIL';

export const GET_ALERTS_YIELD_CHART = 'GET_ALERTS_YIELD_CHART';
export const GET_ALERTS_YIELD_CHART_SUCCESS = 'GET_ALERTS_YIELD_CHART_SUCCESS';
export const GET_ALERTS_YIELD_CHART_FAIL = 'GET_ALERTS_YIELD_CHART_FAIL';

export const GET_ALERTS_ANOMALIES_CHART = 'GET_ALERTS_ANOMALIES_CHART';
export const GET_ALERTS_ANOMALIES_CHART_SUCCESS =
  'GET_ALERTS_ANOMALIES_CHART_SUCCESS';
export const GET_ALERTS_ANOMALIES_CHART_FAIL =
  'GET_ALERTS_ANOMALIES_CHART_FAIL';

export const GET_NOISSUE_L1_CHART = 'GET_NOISSUE_L1_CHART';
export const GET_NOISSUE_L1_CHART_SUCCESS = 'GET_NOISSUE_L1_CHART_SUCCESS';
export const GET_NOISSUE_L1_CHART_FAIL = 'GET_NOISSUE_L1_CHART_FAIL';

export const GET_STR_CHART = 'GET_STR_CHART';
export const GET_STR_CHART_SUCCESS = 'GET_STR_CHART_SUCCESS';
export const GET_STR_CHART_FAIL = 'GET_STR_CHART_FAIL';

export const GET_CUSTOMER_CLUSTER_CHART = 'GET_CUSTOMER_CLUSTER_CHART';
export const GET_CUSTOMER_CLUSTER_CHART_SUCCESS =
  'GET_CUSTOMER_CLUSTER_CHART_SUCCESS';
export const GET_CUSTOMER_CLUSTER_CHART_FAIL =
  'GET_CUSTOMER_CLUSTER_CHART_FAIL';

export const GET_SEGMENT_LIST_DATA = 'GET_SEGMENT_LIST_DATA';
export const GET_SEGMENT_LIST_DATA_SUCCESS = 'GET_SEGMENT_LIST_DATA_SUCCESS';
export const GET_SEGMENT_LIST_DATA_FAIL = 'GET_SEGMENT_LIST_DATA_FAIL';

export const GET_ALERT_STATUS_CHART = 'GET_ALERT_STATUS_CHART';
export const GET_ALERT_STATUS_CHART_SUCCESS = 'GET_ALERT_STATUS_CHART_SUCCESS';
export const GET_ALERT_STATUS_CHART_FAIL = 'GET_ALERT_STATUS_CHART_FAIL';

export const GET_CUSTOMER_DATA = 'GET_CUSTOMER_DATA';
export const GET_CUSTOMER_DATA_SUCCESS = 'GET_CUSTOMER_DATA_SUCCESS';
export const GET_CUSTOMER_DATA_FAIL = 'GET_CUSTOMER_DATA_FAIL';

export function getFigureData(payload) {
  return {
    type: GET_FIGURE_DATA,
    payload
  };
}

export function getFigureDataSuccess(payload) {
  return {
    type: GET_FIGURE_DATA_SUCCESS,
    payload
  };
}

export function getAlertsYieldChartFail(payload) {
  return {
    type: GET_ALERTS_YIELD_CHART_FAIL,
    payload
  };
}

export function getAlertsYieldChart(payload) {
  return {
    type: GET_ALERTS_YIELD_CHART,
    payload
  };
}

export function getAlertsYieldChartSuccess(payload) {
  return {
    type: GET_ALERTS_YIELD_CHART_SUCCESS,
    payload
  };
}

export function getAlertsAnomaliesChartFail(payload) {
  return {
    type: GET_ALERTS_ANOMALIES_CHART_FAIL,
    payload
  };
}

export function getAlertsAnomaliesChart(payload) {
  return {
    type: GET_ALERTS_ANOMALIES_CHART,
    payload
  };
}

export function getAlertsAnomaliesChartSuccess(payload) {
  return {
    type: GET_ALERTS_ANOMALIES_CHART_SUCCESS,
    payload
  };
}

export function getNoIssueL1ChartFail(payload) {
  return {
    type: GET_NOISSUE_L1_CHART_FAIL,
    payload
  };
}

export function getNoIssueL1Chart(payload) {
  return {
    type: GET_NOISSUE_L1_CHART,
    payload
  };
}

export function getNoIssueL1ChartSuccess(payload) {
  return {
    type: GET_NOISSUE_L1_CHART_SUCCESS,
    payload
  };
}

export function getStrChartFail(payload) {
  return {
    type: GET_STR_CHART_FAIL,
    payload
  };
}

export function getStrChart(payload) {
  return {
    type: GET_STR_CHART,
    payload
  };
}

export function getStrChartSuccess(payload) {
  return {
    type: GET_STR_CHART_SUCCESS,
    payload
  };
}

export function getCustomerClusterChartFail(payload) {
  return {
    type: GET_CUSTOMER_CLUSTER_CHART_FAIL,
    payload
  };
}

export function getCustomerClusterChart(payload) {
  return {
    type: GET_CUSTOMER_CLUSTER_CHART,
    payload
  };
}

export function getCustomerClusterChartSuccess(payload) {
  return {
    type: GET_CUSTOMER_CLUSTER_CHART_SUCCESS,
    payload
  };
}

export function getAlertStatusChartFail(payload) {
  return {
    type: GET_ALERT_STATUS_CHART_FAIL,
    payload
  };
}

export function getAlertStatusChart(payload) {
  return {
    type: GET_ALERT_STATUS_CHART,
    payload
  };
}

export function getAlertStatusChartSuccess(payload) {
  return {
    type: GET_ALERT_STATUS_CHART_SUCCESS,
    payload
  };
}

export function getSegmentListDataFail(payload) {
  return {
    type: GET_SEGMENT_LIST_DATA_FAIL,
    payload
  };
}

export function getSegmentListData(payload) {
  return {
    type: GET_SEGMENT_LIST_DATA,
    payload
  };
}

export function getSegmentListDataSuccess(payload) {
  return {
    type: GET_SEGMENT_LIST_DATA_SUCCESS,
    payload
  };
}

export function getFigureDataFail(payload) {
  return {
    type: GET_FIGURE_DATA_FAIL,
    payload
  };
}

export function getCustomerData(payload) {
  return {
    type: GET_CUSTOMER_DATA,
    payload
  };
}

export function getCustomerDataSuccess(payload) {
  return {
    type: GET_CUSTOMER_DATA_SUCCESS,
    payload
  };
}

export function getCustomerDataFail(payload) {
  return {
    type: GET_CUSTOMER_DATA_FAIL,
    payload
  };
}
